import { MEDAL_AWARD_ROLES, type MeResponse, type RoleCode } from "@seagames/contracts";

/**
 * Who may use MSES: the medal desk (`MEDAL_AWARD_ROLES` = MEDAL_DESK) and
 * nobody else — decided by the ACTIVE role only (one active role per session,
 * CLAUDE.md § Auth invariants). An administrator who also runs OVR holds
 * MEDAL_DESK beside ADMIN and continues as it here; acting as ADMIN they get
 * the no-access screen with that switch, because the API takes awards,
 * changes and locks from MEDAL_DESK alone.
 *
 * The API enforces the same list on every write; this only says so up front.
 */
export type MsesAccess = "desk" | "none";

const includes = (list: readonly RoleCode[], role: RoleCode | null | undefined): boolean => role != null && list.includes(role);

export function msesAccessFor(role: RoleCode | null | undefined): MsesAccess {
	return includes(MEDAL_AWARD_ROLES, role) ? "desk" : "none";
}

/** Held roles (other than the active one) that WOULD open MSES — for the no-access screen's switcher. */
export function usableOtherRoles(session: MeResponse): RoleCode[] {
	return session.roles.map((r) => r.code).filter((code) => code !== session.active_role && msesAccessFor(code) !== "none");
}

/** The role the sign-in form asks for: MSES never signs in as anything else. */
export const MSES_SIGN_IN_ROLE: RoleCode = MEDAL_AWARD_ROLES[0];
